/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const AI_STRINGS = {
  addQuestion: 'Add question',
  aiChatbots: 'AI chatbots',
  aiChatbotsDescription: `Provides AI powered chatbot functionality for use across any website.`,
  aiContentTools: 'AI content tools',
  aiContentToolsDescription:
    'Provides AI powered language manipulation tools for use within the page building experience.',
  apiError: `There was a problem completing your request. Please try again later.`,
  apply: 'Apply',
  artificialIntelligence: 'Artificial intelligence',
  authTypeLabel: 'Auth Type',
  availableTools: 'Available tools',
  availableToolsDescription:
    'These are the tools available for use in your system. The list order reflects the order of appearance for content editors.',
  availableToolsEmpty: 'There are currently no available tools.',
  cancel: `Cancel`,
  changesSaved: 'Changes saved',
  contextItemCreated: 'Context item created',
  contextItemsEmpty: 'There are currently no available context items.',
  contexts: 'Contexts',
  contextsDescription:
    'Enhance the ability of this chatbot to engage with users by providing targeted reference material relating to your specific topic requirements.',
  contextsEmpty: 'There are currently no available contexts.',
  conversation: 'Conversation',
  conversations: 'Conversations',
  conversationsHistoryEmpty: 'This chatbot has no conversation history yet.',
  conversationsHistoryTableDescription: 'Review the usage and engagement of this chatbot.',
  conversationsHistoryTableHeading: 'Conversation history',
  conversationsInLast30Days: 'Conversations in last 30 days',
  create: `Create`,
  createAndRunToAudit: 'Create and run tests to audit content quality.',
  createChatbot: 'Create chatbot',
  createChatbotDialogDescription: `Provide a name for the new chatbot. Once created you can configure its functionality. New chatbots are disabled by default.`,
  createContextItem: 'Create context item',
  createTest: 'Create test',
  createTool: 'Create tool',
  createToolDialogDescription: `Provide a name for the new tool. Once created you can configure its functionality. New tools are disabled by default.`,
  currentChatbots: 'Current chatbots',
  currentChatbotsDescription: 'These are the chatbots configured for use in your system.',
  currentChatbotsEmpty: 'There are currently no available chatbots.',
  dashboard: 'Dashboard',
  date: 'Date',
  dateCreated: 'Date created',
  delete: 'Delete',
  deleteChatbot:
    'Deleting a chatbot is a global action across all your sites. Any usage history will be removed and the chatbot will no longer be available.',
  deleteChatbotHeading: 'Delete chatbot',
  deleteContentTool:
    'Deleting a content tool is a global action across all your sites and page building experiences. Any usage history will be removed and the tool will no longer be available to content editors.',
  deleteContentToolHeading: 'Delete content tool',
  deleteContextItem: 'Delete context item',
  deleteContextItemConfirmation:
    'Are you sure you want to delete this context item? This action is instant and cannot be undone.',
  deleteContextItemFailed: 'Failed to delete context item',
  deleteContextItemSuccess: 'Context item deleted',
  deleteDialogText2: 'This action is instant and cannot be undone.',
  description: 'Description',
  details: 'Details',
  disabled: 'disabled',
  edit: 'Edit',
  editChatbotDialogHeading: 'Edit chatbot',
  editContentToolDialogHeading: `Edit content tool`,
  editContextItem: 'Edit context item',
  enableChatbot: `Enable this chatbot`,
  enabled: 'enabled',
  enableToggleFieldDescriptionChatbot: `This is a global switch to allow access to this chatbot on the web.`,
  enableToggleFieldDescriptionGenerative: `A global switch to manage this tool’s general availability.`,
  enableTool: `Enable this tool`,
  error: 'Error',
  executionCancelled: 'Execution cancelled',
  executionFailed: 'Execution failed',
  failedToCreateOrUpdateContextItem: 'Failed to create or update context item',
  feedback: 'Feedback',
  filterByTags: 'Search tags',
  flaggedForReview: 'Flagged for review',
  flaggedInLast30Days: 'Flagged in last 30 days',
  id: 'ID',
  initiated: 'Initiated',
  inProgressContentTransformation: 'In-progress content transformation',
  inProgressContentTransformationTitle: 'The title is currently being generated.',
  inProgressConversation: 'In-progress conversation',
  inProgressConversationTitle: 'The title and tags will be populated once the conversation has completed.',
  inputEmpty: 'Please enter some text',
  instructionFieldDescription: `Define the instruction set sent to the AI in order to produce the functionality required for this tool.`,
  instructionFieldDescriptionAlt: 'The instructions given to the AI in order to perform this tools function.',
  instructionFieldDescriptionChatbot: `Define the guidelines for this chatbot's behavior, such as preferred tone, permissible topics, and conversation restrictions.`,
  instructionFieldDescriptionChatbotAlt: `The defined guidelines for this chatbot’s behavior.`,
  instructions: `Instructions`,
  instructionsFieldLength: 'Instructions should be between {{min}} and {{max}} characters.',
  lastRun: 'Last run',
  lastUpdated: 'Last updated',
  loadMore: `Load more`,
  name: 'Name',
  nameAlreadyInUse: 'This name is already in use.',
  nameFieldDescriptionChatbot: ``,
  nameFieldDescriptionGenerative: `This name will be visible to editors when editing text content in the page building experience.`,
  nameFieldLength: 'Name should be between 1 and 50 characters in length.',
  nameSlashId: 'Name/ID',
  negative: 'Negative',
  noTestsHaveBeenCreatedYet: 'No tests have been created yet.',
  placeholder: 'Placeholder',
  positive: 'Positive',
  provideTestName:
    'Provide a name for the test. Once created you can configure its questions and reference responses. Then you can run the test and view the results.',
  question: 'Question',
  questions: 'Questions',
  rating: 'Rating',
  ratingsInLast30Days: 'Ratings in last 30 days',
  referenceResponse: 'Reference response',
  requiredField: `This field is required`,
  response: `Response`,
  responses: 'Responses',
  responsesEmpty: 'This content tool has no responses yet.',
  responsesTableDescription: 'Review the usage of this content tool.',
  responsesTableHeading: 'Usage history',
  review: `Review usage`,
  reviewConversation: `Review Conversation`,
  run: 'Run',
  runsIn30Days: 'Runs in the last 30 days',
  runTest: 'Run test',
  save: 'Save',
  search: 'Search',
  semanticAuditor: 'Semantic auditor',
  semanticAuditorDescription: `Create and run tests to audit and help improve content. `,
  semanticAuditorTestBuilder: 'Semantic auditor test builder',
  semanticTester: 'Semantic tester',
  somethingWentWrong: 'Something went wrong. Please try again.',
  status: 'Status',
  tags: 'Tags',
  tagsFieldDescription: 'Tags classify this tool and manage its visibility for each site.',
  testChatbotInputPlaceholder: 'Type message here...',
  testChatbotOutputPlaceholder:
    '<p>You are previewing how the chatbot responds to queries it receives. This chatbot has been given the instructions:</p><p>{{instructions}}</p>',
  testCreated: 'Test created',
  testRuns: 'Test runs',
  tests: 'Tests',
  testTool: 'Test',
  testToolInputPlaceHolder: 'Type something...',
  testToolOutputPlaceHolder: 'Use the input panel to enter content; then run the tool to see the output here.',
  thereAreCurrentlyNoTestResults: 'There are currently no test results.',
  thereAreErrorsInTheForm: 'There are errors in the form. Please review highlighted fields and try again.',
  threadId: 'Thread ID',
  threadTitle: 'Name',
  timeLastInteracted: 'Last Interaction',
  totalRuns: 'Total runs',
  unrated: 'Unrated',
  usageInLast30Days: 'Usage in last 30 days',
  userAction: 'User action',
  viewChatbot: 'View chatbot',
  viewChatbotContext: 'View chatbot context',
  viewContentTool: 'View Content Tool',
  writeQuestionToAskChatbot: 'Write the question you want to ask the chatbot.',
  writeResponseToCompare: 'Write the response you want to compare the chatbot’s response to.',
  writeTheQuestionsYouWant:
    'Write the questions you want to ask the chatbot. Optionally add reference responses to assist with reviewing and rating test results.',
  youHaveSuccessfullyCreatedContextItem: 'You have successfully created the context item "{{contextItemId}}"',
  youHaveSuccessFullyCreatedTest: 'You have successfully created the test <i>{{name}}</i>.',
};

export const AI_IDS = {
  createTestDialogLauncher: 'Button: Open semantic auditor test creation dialog',
  deleteTest: 'Dropdown: Delete semantic auditor test',
  deleteToastFailed: `Toast: AI context item deletion failed`,
  deleteToastSuccess: `Toast: AI context item deleted successfully`,
};

export const AI_FORM_IDS = {
  testInput: 'test-input',
};
